import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { GenericComponentsModule } from '@helios/generic-components'
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap'
import { NgSelectModule } from '@ng-select/ng-select'
import { NfAgGridModule, TableLayoutModule } from '@northfork/ag-grid-angular'
import { DaterangeModule, NfFormsModule } from '@northfork/ng-basics'
import { AgChartsAngularModule } from 'ag-charts-angular'
import { PricingChartsComponent } from './pricing-charts/pricing-charts.component'
import { PricingDataBySourceTableComponent } from './pricing-data-by-source-table/pricing-data-by-source-table.component'
import { PricingDataMenuComponent } from './pricing-data-menu/pricing-data-menu.component'
import { PricingPanelComponent } from './pricing-panel.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NfFormsModule,
    DaterangeModule,
    NgSelectModule,
    ReactiveFormsModule,
    TableLayoutModule,
    NgbNavModule,
    GenericComponentsModule,
    AgChartsAngularModule,
    NfAgGridModule.forRoot({
      gridClass: 'ag-theme-northfork-compact',
      autoResize: false,
    }),
  ],
  declarations: [
    PricingPanelComponent,
    PricingDataMenuComponent,
    PricingDataBySourceTableComponent,
    PricingChartsComponent,
  ],
  exports: [PricingPanelComponent],
})
export class PricingModule {}

export { PricingPanelComponent }
